import React from 'react';
import PropTypes from 'prop-types';
import MainContainer from './MainContainer';
import Header from '../Header';

const Layout = ({ children, containerProps = {} }) => {
    return (
        <div className="min-h-screen bg-gray-100">
            {/* Header is always rendered, regardless of any props */}
            <Header isOpen={true} />

            {/* Content area with padding */}
            <div className="py-6 px-4 sm:px-6 lg:px-8">
                <MainContainer {...containerProps}>
                    {children}
                </MainContainer>
            </div>
        </div>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    containerProps: PropTypes.object
};

export default Layout;